import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {fetchProducts} from "./coreProductsSlice";

export default function Specials(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    let jwtToken = localStorage.getItem("clientToken");

    useEffect(() => {
        dispatch(
            fetchProducts({
                token: jwtToken,
                query: location.search || '?special=true&order_by=name&sort=asc&limit=24',
            })
        );

        history.push('/products');
    }, [dispatch, history, location.search]);

    return null;
}